export default {
  loading: 'Chargement',
  delivery: 'Livraison',
  address: 'Adresse',
  housing: 'Logement',
  floor: 'Étage',
  elevator: 'Ascenseur',
  furnitureTransport: 'Accessibilité',
  parkingArea: 'Stationnement',
  rooms: 'Pièces',
  serviceOffer: 'Prestations',
  dates: 'Dates',
  services: 'Services',
  assurance: 'Assurance',
  furnitures: 'Inventaire',
  inventory: 'Meubles',
  boxConfig: 'Cartons à déménager',
  boxDelivery: 'Cartons à fournir',
  validate: 'Validation',
};
